import { Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { SearchSettings } from 'app/back-office/shared/models/common/search-settings.model';
import { GetProductsParams, ProductsService } from 'app/back-office/shared/services/back-office/products.service';
import { FilterMapper } from 'app/back-office/shared/utilities/filter-mapper';
import { InternalFilterGroup, FilterItem } from 'app/shared/models/filter-group.models';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';

@Component({
    selector: 'app-products-filter',
    templateUrl: './products-filter.component.html',
    styleUrls: ['./products-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProductsFilterComponent implements OnInit, OnChanges {
  @Input() filter: InternalFilterGroup;
  @Input() accordionState: boolean;
  loaderId = UtilityFunctions.newGuid();

  searchSettings: SearchSettings = {
    placeholder: 'Search product...',
    inputId: UtilityFunctions.newGuid(),
    showFilters: false,
  };

  totalCount = 0;
  searchValue = '';
  cacheFilterData: FilterItem[];
  dataToView: FilterItem[] = [];
  constructor(private productService: ProductsService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.accordionState && this.accordionState && this.dataToView.length === 0) {
      this.setDataToView(0);
    }
  }

  ngOnInit(): void {
  }


  onSearch(search: string) {
    this.searchValue = search;
    this.setDataToView(0);
  }

  setDataToView(skipCount: number) {
    const filters: GetProductsParams = {
      skipCount,
      maxResultCount: 20,
      search: this.searchValue,
      includeVariants: false,
      includeMedia: false,
      includeVariantMedia: false,
      assortmentId: null,
    };

    this.productService.getProducts(this.loaderId, filters).subscribe(res => {
      this.dataToView = res.items.map(el => FilterMapper.productFilter(el));
      this.totalCount = res.totalCount;
    });
  }
  getNextData(skipCount: number) {
    if (this.totalCount > skipCount) {
      const next = skipCount;
      this.setDataToView(next);
    }
  }

}
